import React, { Fragment } from "react";
import DateCell from "./DateCell";

const CalendarBody = React.memo(
  ({
    calendarData,
    gridConfig,
    dropActiveIndex,
    droppingIndex,
    onPlanDoubleClick,
    dragDropProps,
    dragDropHandlers,
  }) => {
    return (
      <>
        {calendarData.calendarBody.map((line, lineIndex) => (
          <Fragment key={line.line_id}>
            {/* Line Name */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #ccc",
                backgroundColor: "#f9f9f9",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "5px",
                gridColumn: `span ${gridConfig.lineListColumns}`,
                fontWeight: "bold",
              }}
            >
              {line.line_name}
            </div>

            {/* Date Cells */}
            {line.dates.map((dateObj, dateIndex) => (
              <DateCell
                key={`${lineIndex}-${dateIndex}`}
                dateObj={dateObj}
                line={line}
                lineIndex={lineIndex}
                dateIndex={dateIndex}
                dayWithDutyColumns={gridConfig.dayWithDutyColumns}
                dropActiveIndex={dropActiveIndex}
                droppingIndex={droppingIndex}
                onPlanDoubleClick={onPlanDoubleClick}
                dragDropProps={dragDropProps}
                dragDropHandlers={dragDropHandlers}
              />
            ))}
          </Fragment>
        ))}
      </>
    );
  },
);

CalendarBody.displayName = "CalendarBody";

export default CalendarBody;
